export default "__VITE_ASSET__1UfaZ9Nu__"